import type { ListSchoolsParams } from "./api"

export const schoolKeys = {
  all: ["schools"] as const,
  lists: () => [...schoolKeys.all, "list"] as const,
  list: (params: ListSchoolsParams) => [...schoolKeys.lists(), { ...params }] as const,
  options: (institutionId: string) => [...schoolKeys.all, "options", institutionId] as const,
  details: () => [...schoolKeys.all, "detail"] as const,
  detail: (id: string) => [...schoolKeys.details(), id] as const,
  // PRD-61 FR-1.5 — a school's EFFECTIVE calendar (its own, or inherited).
  // `null` is "the year in course", which the API resolves.
  calendars: () => [...schoolKeys.all, "calendar"] as const,
  calendarsFor: (id: string) => [...schoolKeys.calendars(), id] as const,
  calendar: (id: string, schoolYear: string | null) =>
    [...schoolKeys.calendarsFor(id), schoolYear ?? "current"] as const,
}

export const subjectKeys = {
  all: ["subjects"] as const,
  lists: () => [...subjectKeys.all, "list"] as const,
  // Partial key — matches both the active-only and include-deleted variants
  // for a school in one `invalidateQueries` call (TanStack prefix-matches).
  listsForSchool: (schoolId: string) => [...subjectKeys.lists(), schoolId] as const,
  list: (schoolId: string, includeDeleted = false) =>
    [...subjectKeys.listsForSchool(schoolId), { includeDeleted }] as const,
}
